import http from '~/common/http'
export default {
    getView(params) {
        return http.get('/api/user-path-config/view', {
            params: params
        });
    },

    create(data) {
        return http.post("/api/user-path-config/create", data);
    },

    update(data) {
        return http.put("/api/user-path-config/update", data);
    },
}


// WEBPACK FOOTER //
// ./src/services/UserPathConfig.js